module.exports = __webpack_public_path__ + "static/media/location-maps-letter-h-arrow-serr1.51404a7e.png";